import { render, staticRenderFns } from "./FilmcodePicker.vue?vue&type=template&id=2bc35810&scoped=true&"
import script from "./FilmcodePicker.vue?vue&type=script&lang=js&"
export * from "./FilmcodePicker.vue?vue&type=script&lang=js&"
import style0 from "./FilmcodePicker.vue?vue&type=style&index=0&id=2bc35810&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc35810",
  null
  
)

export default component.exports